module.exports = __webpack_public_path__ + "img/626262_A8A8A8_949494_1F1F1F-256px.e59d6067.png";